import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, KeepAlive as _KeepAlive, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2d9c9f64"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "brand-portfolio-table"
};
const _hoisted_2 = {
  class: "period"
};
const _hoisted_3 = {
  class: "roas-tacos"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_th = _resolveComponent("b-th");
  const _component_app_dropdown = _resolveComponent("app-dropdown");
  const _component_b_tr = _resolveComponent("b-tr");
  const _component_b_thead = _resolveComponent("b-thead");
  const _component_brand_portfolio_parent_row = _resolveComponent("brand-portfolio-parent-row");
  const _component_brand_portfolio_children_row = _resolveComponent("brand-portfolio-children-row");
  const _component_b_tbody = _resolveComponent("b-tbody");
  const _component_b_table_simple = _resolveComponent("b-table-simple");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_b_table_simple, {
    bordered: "",
    responsive: "",
    fixed: "",
    "sticky-header": ""
  }, {
    default: _withCtx(() => [_createElementVNode("colgroup", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.columnWidths, (width, index) => {
      return _openBlock(), _createElementBlock("col", {
        key: index,
        style: _normalizeStyle(width ? {
          width
        } : null)
      }, null, 4);
    }), 128))]), _createVNode(_component_b_thead, null, {
      default: _withCtx(() => [_createVNode(_component_b_tr, null, {
        default: _withCtx(() => [_createVNode(_component_b_th, {
          colspan: "1",
          "sticky-column": ""
        }), _createVNode(_component_b_th, {
          colspan: "3",
          class: "yearly-trend"
        }, {
          default: _withCtx(() => [_createTextVNode("Yearly trend")]),
          _: 1
        }), _createVNode(_component_b_th, {
          colspan: "4",
          class: "last-n-trend"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_app_dropdown, {
            modelValue: $data.selected_period,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.selected_period = $event),
            options: $data.period
          }, null, 8, ["modelValue", "options"]), _createTextVNode(" trend ")])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_b_tr, {
        class: "brand-portfolio-table-header"
      }, {
        default: _withCtx(() => [_createVNode(_component_b_th, {
          rowspan: "2",
          "sticky-column": ""
        }, {
          default: _withCtx(() => [_createTextVNode("Workspace")]),
          _: 1
        }), _createVNode(_component_b_th, {
          colspan: "3",
          class: "revenue-evol-header center"
        }, {
          default: _withCtx(() => [_createTextVNode("Revenue evolution vs LY")]),
          _: 1
        }), _createVNode(_component_b_th, {
          rowspan: "2"
        }, {
          default: _withCtx(() => [_createTextVNode("Current period revenue")]),
          _: 1
        }), _createVNode(_component_b_th, {
          colspan: "2",
          class: "th-roas-tacos"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_3, "Last " + _toDisplayString($data.period_unit[$data.selected_period]), 1)]),
          _: 1
        }), _createVNode(_component_b_th, {
          rowspan: "2",
          class: "portfolio-td-spend"
        }, {
          default: _withCtx(() => [_createTextVNode("End of week SP spend forecast")]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_b_tr, {
        class: "brand-portfolio-table-header center"
      }, {
        default: _withCtx(() => [_createVNode(_component_b_th, {
          class: "time-frame"
        }, {
          default: _withCtx(() => [_createTextVNode("YTD")]),
          _: 1
        }), _createVNode(_component_b_th, {
          class: "time-frame"
        }, {
          default: _withCtx(() => [_createTextVNode("MTD")]),
          _: 1
        }), _createVNode(_component_b_th, {
          class: "time-frame border-right"
        }, {
          default: _withCtx(() => [_createTextVNode("WTD")]),
          _: 1
        }), _createVNode(_component_b_th, null, {
          default: _withCtx(() => [_createTextVNode("TACOS")]),
          _: 1
        }), _createVNode(_component_b_th, {
          style: {
            "border-right": "1px solid #e3e3e3 !important"
          }
        }, {
          default: _withCtx(() => [_createTextVNode("ROAS")]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_b_tbody, null, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parent_workspace_to_child_workspace_map, ([parent, children]) => {
        return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_brand_portfolio_parent_row, {
          portfolio: parent,
          children: children,
          loading: $data.loading,
          periodLength: $options.periodLength,
          period_data: $data.period_data,
          selected_period: $data.selected_period,
          onOnWorkspaceRowClickHandler: $options.onWorkspaceRowClickHandler,
          onOnWorkspaceNameClickHandler: $options.onWorkspaceNameClickHandler,
          onOnWorkspaceAlertClickHandler: $options.onWorkspaceAlertClickHandler
        }, null, 8, ["portfolio", "children", "loading", "periodLength", "period_data", "selected_period", "onOnWorkspaceRowClickHandler", "onOnWorkspaceNameClickHandler", "onOnWorkspaceAlertClickHandler"]), (_openBlock(), _createBlock(_KeepAlive, null, [!parent.collapsed ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(children, (child, index) => {
          return _openBlock(), _createBlock(_component_brand_portfolio_children_row, {
            portfolio: child,
            loading: $data.loading,
            periodLength: $options.periodLength,
            period_data: $data.period_data,
            selected_period: $data.selected_period,
            isLastSellerInWorkspace: index == children.length - 1,
            onOnSellerNameClickHandler: $options.onSellerNameClickHandler,
            onOnWorkspaceAlertClickHandler: $options.onWorkspaceAlertClickHandler
          }, null, 8, ["portfolio", "loading", "periodLength", "period_data", "selected_period", "isLastSellerInWorkspace", "onOnSellerNameClickHandler", "onOnWorkspaceAlertClickHandler"]);
        }), 256)) : _createCommentVNode("", true)], 1024))], 64);
      }), 256))]),
      _: 1
    })]),
    _: 1
  })]);
}